import { siteConfig } from "../config/siteConfig";
import { Phone, Mail, MapPin } from "lucide-react";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

export default function UnderConstruction() {
  const { hotel, contact, bookingLinks } = siteConfig;

  return (
    <div
      data-testid="under-construction-page"
      className="min-h-screen flex flex-col items-center justify-center text-center px-6 py-16 relative"
      style={{
        background:
          "linear-gradient(180deg, #faf9f6 0%, #f3efe6 60%, #ebe5d9 100%)",
      }}
    >
      <div className="max-w-2xl mx-auto">
        <img
          src={hotel.logoUrl}
          alt={hotel.name}
          className="w-32 h-32 sm:w-40 sm:h-40 mx-auto mb-8 object-contain"
          data-testid="uc-logo"
        />
        <p className="font-overline mb-4">{hotel.location} · Sri Lanka</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A362D] mb-4">
          {hotel.name}
        </h1>
        <div className="gold-divider mb-8"></div>
        {/* <h2 className="font-display text-2xl sm:text-3xl text-[#5C4033] mb-6">
          Our website is currently under construction
        </h2> */}
        <h2 className="font-display text-2xl sm:text-3xl text-[#5C4033] mb-6">
          We are delighted to welcome you from Saturday, 23rd May 2026.
        </h2>
        {/* <p className="text-[#2C2C2C] text-base sm:text-lg leading-relaxed mb-10">
          We're crafting something elegant for you. In the meantime, you can
          reach us directly through WhatsApp, phone, Booking.com or Agoda to
          check availability and reserve your stay.
        </p> */}

        <p className="text-[#2C2C2C] text-base sm:text-lg leading-relaxed mb-10">
         Until then, you can contact us directly through WhatsApp orphone to check availability and reserve your stay.
        </p>

        <div className="flex flex-wrap justify-center gap-3 mb-12">
          <a
            href={`https://wa.me/${contact.whatsapp}?text=${encodeURIComponent(
              siteConfig.whatsappDefaultMessage
            )}`}
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
            data-testid="uc-whatsapp-btn"
          >
            WhatsApp Us
          </a>
          {/* <a
            href={bookingLinks.bookingCom}
            target="_blank"
            rel="noreferrer"
            className="btn-outline-dark"
            data-testid="uc-bookingcom-btn"
          >
            Booking.com
          </a>
          <a
            href={bookingLinks.agoda}
            target="_blank"
            rel="noreferrer"
            className="btn-outline-dark"
            data-testid="uc-agoda-btn"
          >
            Agoda
          </a> */}
        </div>

        <div className="grid sm:grid-cols-3 gap-6 text-sm text-[#2C2C2C]">
          <div className="flex flex-col items-center gap-2">
            <Phone className="w-5 h-5 text-[#C5A059]" strokeWidth={1.5} />
            <a href={`tel:${contact.phone}`} className="hover:text-[#C5A059]">
              {contact.phone}
            </a>
          </div>
          <div className="flex flex-col items-center gap-2">
            <Mail className="w-5 h-5 text-[#C5A059]" strokeWidth={1.5} />
            <a
              href={`mailto:${contact.email}`}
              className="hover:text-[#C5A059]"
            >
              {contact.email}
            </a>
          </div>
          <div className="flex flex-col items-center gap-2">
            <MapPin className="w-5 h-5 text-[#C5A059]" strokeWidth={1.5} />
            <span>{contact.address}</span>
          </div>
        </div>
      </div>
      <FloatingWhatsApp />
    </div>
  );
}
